/**
 * 📦 V2 Managers API client
 * Rotas /api/v2/managers (vínculo gerente × produto)
 * Spec: docs/V2/07_REGRAS_NEGOCIO.md §3.1 + §3.4
 */

import v2Api from './index';

export const managersV2API = {
  /**
   * Produtor convida manager.
   * Body: { product_id, user_id, commission_value_override?, can_manage_affiliates? }
   */
  create: (data) => v2Api.post('/managers', data),

  /**
   * Convida manager por EMAIL. 409 CONFLICT se já existir manager ativo.
   * Body: { product_id, email, commission_value_override?, can_manage_affiliates? }
   */
  invite: (data) => v2Api.post('/managers/invite', data),

  /** Lista managers do produto. */
  listByProduct: (productId) => v2Api.get(`/managers/by-product/${productId}`),

  /** Lista produtos onde o user é manager. */
  listMine: () => v2Api.get('/managers/me'),

  findById: (id) => v2Api.get(`/managers/${id}`),

  activate: (id) => v2Api.post(`/managers/${id}/activate`),

  deactivate: (id) => v2Api.post(`/managers/${id}/deactivate`),

  /** body: { commission_value_override } */
  updateCommissionOverride: (id, data) =>
    v2Api.patch(`/managers/${id}/commission-override`, data),

  /** body: { can_manage_affiliates } */
  updatePermissions: (id, data) =>
    v2Api.patch(`/managers/${id}/permissions`, data),

  remove: (id) => v2Api.delete(`/managers/${id}`),
};

export default managersV2API;
